import { selectionDataContext } from '../../../hooks/context/SelectionDataContext'
import { useContext } from 'react'

export const useTCDataHook = () => {
    const selectionDataCtx:any = useContext(selectionDataContext)
    const payload=selectionDataCtx.data
    return payload
 }